import React, { createContext, useState, useEffect } from "react";
import { getTenantActivityLog } from "../../../api/Api";
import RouteConstants from "../../../constants/routeConstants.json";
import ContentData from "../../../constants/contentFile.json";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

export const TenantActivityContext = createContext({});
export const TenantActivityContextProvider = ({ children }) => {
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [tenantActivityList, setTenantActivityList] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [statusValue, setStatusValue] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  const onPageChange = (e) => {
    setCurrentPage(e);
  };

  const goToLogin = () => {
    removeCookie("x-access-token");
    navigate(RouteConstants.LOGIN);
  };

  const goToTenantList = () => {
    navigate(RouteConstants.TENANT_LIST);
  };

  const onHandleClose = () => {
    setErrorPopup(false);
  };

  const tenantActivityListShow = async (page) => {
    try {
      setSpinnerStatus(true);
      const getActivityList = await getTenantActivityLog(page);
      const logs = getActivityList?.data?.data?.logs;

      if (getActivityList?.status === 200) {
        if (logs.length > 0) {
          setSpinnerStatus(false);
          setTenantActivityList((prevLogs) => [...prevLogs, ...logs]);
          setCurrentPage(page);
        } else {
          setHasMore(false);
        }
      }
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || ContentData.tenantPage.wentWrong;

      setStatusValue(responseStatus);
      setErrorPopupMessage(errorMessage);
      setErrorPopup(true);

      if (responseStatus === 400) {
        setButtonText(ContentData.tenantPage.tryAgain);
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText(ContentData.tenantPage.login);
      } else {
        setButtonText(ContentData.tenantPage.tryAgain);
      }
      setSpinnerStatus(false);
    }
    setSpinnerStatus(false);
  };

  useEffect(() => {
    tenantActivityListShow(currentPage);
  }, []);

  const providerValue = {
    spinnerStatus,
    errorPopup,
    errorPopupMessage,
    buttonText,
    tenantActivityList,
    formatDate,
    formatTime,
    currentPage,
    totalPage,
    goToTenantList,
    setErrorPopup,
    goToLogin,
    statusValue,
    tenantActivityListShow,
    hasMore,
  };

  return (
    <TenantActivityContext.Provider value={providerValue}>
      {children}
    </TenantActivityContext.Provider>
  );
};
